/**
 * /design-check/invite/:token — the invite link IS the login.
 * Redeems the token for a session, stores the same localStorage keys the
 * portal login uses, then hard-navigates into the app so App.js picks up
 * the fresh auth state on mount.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import './DesignCheck.css';

function InviteLanding() {
  const { token } = useParams();
  const [state, setState] = useState('working'); // working | welcome | error
  const [error, setError] = useState('');
  const [label, setLabel] = useState('');
  const redeemed = useRef(false);

  useEffect(() => {
    if (redeemed.current) return;
    redeemed.current = true;
    (async () => {
      try {
        const res = await fetch('/api/design-check/invite/redeem', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.error || 'This invite link could not be used.');
        }
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('tokenExpiry', String(data.expires));
        localStorage.setItem('currentUser', data.username);
        localStorage.setItem('userRole', data.role);
        setLabel(data.inviteLabel || '');
        setState('welcome');
        setTimeout(() => { window.location.href = '/design-check'; }, 1600);
      } catch (err) {
        setError(err.message);
        setState('error');
      }
    })();
  }, [token]);

  return (
    <div className="dc-shell">
      <div className="dc-center-page">
        {state === 'working' && (
          <>
            <div className="dc-spinner" />
            <h1>Checking your invite…</h1>
          </>
        )}
        {state === 'welcome' && (
          <>
            <div style={{ fontSize: 52 }}>👋</div>
            <h1>Welcome{label ? `, ${label}` : ''}</h1>
            <p>
              You're in. Upload a STEP file and Bob — Rapid Fusion's AI design
              advisor — will check it for large-format 3D printing and tell you
              exactly how to print it.
            </p>
            <div className="dc-spinner" style={{ width: 26, height: 26 }} />
          </>
        )}
        {state === 'error' && (
          <>
            <div style={{ fontSize: 52 }}>🔒</div>
            <h1>This link isn't active</h1>
            <p>{error}</p>
            <p style={{ fontSize: 13 }}>
              Invite links expire for security. Contact your Rapid Fusion representative
              and they'll send you a fresh one in seconds.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default InviteLanding;
